/* eslint-disable import/prefer-default-export */

export const LINKS = {
  LEARN_MORE: 'https://help.fairprice.com.sg/hc/en-us/articles/360041679392',
};

export const COUNTRY_CODE = '65';

export const DEFAULT_TNC =
  'Send me marketing news like exclusive offers via email and text messages.';
